module.exports = __webpack_public_path__ + "static/Dinner 2017-d764b681e1aa496caaeef38febfda505.jpg";